var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _CollapsibleList_instances, _CollapsibleList_node, _CollapsibleList_data, _CollapsibleList_label, _CollapsibleList_max, _CollapsibleList_hiddenItems, _CollapsibleList_button, _CollapsibleList_clickHandler, _CollapsibleList_addButton;
import { $gettext } from "./gettext";
let uniqueId = 0;
class CollapsibleList {
    static fromNode(node) {
        return CollapsibleList.instances.get(node) ?? new CollapsibleList(node);
    }
    constructor(node) {
        _CollapsibleList_instances.add(this);
        _CollapsibleList_node.set(this, void 0);
        _CollapsibleList_data.set(this, void 0);
        _CollapsibleList_label.set(this, $gettext('Einträge'));
        _CollapsibleList_max.set(this, 5);
        _CollapsibleList_hiddenItems.set(this, []);
        _CollapsibleList_button.set(this, null);
        _CollapsibleList_clickHandler.set(this, () => {
            this.update(__classPrivateFieldGet(this, _CollapsibleList_button, "f")?.getAttribute('aria-expanded') === 'true');
        });
        if (!node.matches('ol,ul')) {
            throw new Error('Not applicable for anything else than ol/ul lists');
        }
        if (CollapsibleList.instances.has(node)) {
            throw new Error('CollapsibleList already initialized');
        }
        CollapsibleList.instances.set(node, this);
        __classPrivateFieldSet(this, _CollapsibleList_node, node, "f");
        __classPrivateFieldSet(this, _CollapsibleList_data, node.dataset, "f");
        __classPrivateFieldSet(this, _CollapsibleList_label, __classPrivateFieldGet(this, _CollapsibleList_data, "f").label ?? __classPrivateFieldGet(this, _CollapsibleList_label, "f"), "f");
        __classPrivateFieldSet(this, _CollapsibleList_max, Number.parseInt(__classPrivateFieldGet(this, _CollapsibleList_data, "f").collapseAfter ?? String(__classPrivateFieldGet(this, _CollapsibleList_max, "f")), 10), "f");
        __classPrivateFieldGet(this, _CollapsibleList_node, "f").classList.add('collapsible-list');
        const items = Array.from(__classPrivateFieldGet(this, _CollapsibleList_node, "f").children);
        __classPrivateFieldSet(this, _CollapsibleList_hiddenItems, items.slice(__classPrivateFieldGet(this, _CollapsibleList_max, "f")), "f");
        if (__classPrivateFieldGet(this, _CollapsibleList_hiddenItems, "f").length > 0) {
            __classPrivateFieldGet(this, _CollapsibleList_instances, "m", _CollapsibleList_addButton).call(this);
        }
    }
    update(collapsed) {
        if (__classPrivateFieldGet(this, _CollapsibleList_button, "f") === null) {
            return;
        }
        __classPrivateFieldGet(this, _CollapsibleList_button, "f").textContent = collapsed
            ? $gettext('%{count} weitere %{label} anzeigen', { count: String(__classPrivateFieldGet(this, _CollapsibleList_hiddenItems, "f").length), label: __classPrivateFieldGet(this, _CollapsibleList_label, "f") })
            : $gettext('weniger %{label} anzeigen', { label: __classPrivateFieldGet(this, _CollapsibleList_label, "f") });
        __classPrivateFieldGet(this, _CollapsibleList_button, "f").setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        __classPrivateFieldGet(this, _CollapsibleList_hiddenItems, "f").forEach((li) => {
            li.style.display = collapsed ? 'none' : '';
            li.toggleAttribute('hidden', collapsed);
        });
    }
    destroy() {
        this.update(false);
        __classPrivateFieldGet(this, _CollapsibleList_button, "f")?.removeEventListener('click', __classPrivateFieldGet(this, _CollapsibleList_clickHandler, "f"));
        __classPrivateFieldGet(this, _CollapsibleList_button, "f")?.remove();
        __classPrivateFieldGet(this, _CollapsibleList_node, "f").classList.remove('collapsible-list');
        CollapsibleList.instances.delete(__classPrivateFieldGet(this, _CollapsibleList_node, "f"));
    }
}
_CollapsibleList_node = new WeakMap(), _CollapsibleList_data = new WeakMap(), _CollapsibleList_label = new WeakMap(), _CollapsibleList_max = new WeakMap(), _CollapsibleList_hiddenItems = new WeakMap(), _CollapsibleList_button = new WeakMap(), _CollapsibleList_clickHandler = new WeakMap(), _CollapsibleList_instances = new WeakSet(), _CollapsibleList_addButton = function _CollapsibleList_addButton() {
    const id = __classPrivateFieldGet(this, _CollapsibleList_node, "f").getAttribute('id') ?? `collapsible-list-${uniqueId++}`;
    __classPrivateFieldGet(this, _CollapsibleList_node, "f").setAttribute('id', id);
    __classPrivateFieldSet(this, _CollapsibleList_button, Object.assign(document.createElement('button'), {
        className: 'as-link',
        textContent: '',
        type: 'button',
    }), "f");
    __classPrivateFieldGet(this, _CollapsibleList_button, "f").setAttribute('aria-controls', id);
    __classPrivateFieldGet(this, _CollapsibleList_button, "f").addEventListener('click', __classPrivateFieldGet(this, _CollapsibleList_clickHandler, "f"));
    __classPrivateFieldGet(this, _CollapsibleList_node, "f").after(__classPrivateFieldGet(this, _CollapsibleList_button, "f"));
    this.update(true);
};
CollapsibleList.instances = new WeakMap();
export default CollapsibleList;
